<section class="current-plan-container" [class.mobile]="isMobile">
  <div class="section-title">
      {{ 'text_currentPlan' | dbText}}
  </div>
  <div class="plan-title-container">
    <div class="plan-title">
      {{ (userSubscription?.isDedicatedVM ? userSubscription?.presentableTitle : userSubscription?.title) }}{{ userSubscription?.category === UserSubscriptionCategory?.PROFESSIONAl ? ' ' + ('text_professionalCategory' | dbText) : '' }}
    </div>
    <div class="plan-subtitle">
        {{((userSubscription?.plan?.trialPeriodDays > 1 ? 'text_daysForFree_plural' : 'text_daysForFree_singular') | dbText: {days: userSubscription?.plan?.trialPeriodDays})}}
    </div>
  </div>

  <div class="plan-price-container">
    <div class="price">
      <ng-container *ngIf="isCurrencyBeforeAmount">
        {{ currencySymbol }}{{userSubscription?.plan?.planPrice}}
      </ng-container>
      <ng-container *ngIf="!isCurrencyBeforeAmount">
        {{userSubscription?.plan?.planPrice}} {{ currencySymbol }}
      </ng-container>
    </div>
  </div>

  <div class="plan-options-list" [class.hide]="!fullyOpened">
    <div class="plan-option" *ngFor="let option of currentPlanOptions">
      <i class="db-icon db-icon-ds-checkmark-sharp"></i>
      <span [innerHTML]="option?.title | dbText: {count: option?.value}"></span>
    </div>
    <div class="transparent-cover" *ngIf="isMobile && !fullyOpened"></div>
  </div>

  <div class="show-btn" *ngIf="isMobile" (click)="fullyOpened = !fullyOpened" [class.less]="fullyOpened">
    {{ fullyOpened ? ('text_seeLessFeatures' | dbText) : ('text_seeMoreFeatures' | dbText) }} <i class="db-icon db-icon-new-down-arrow"></i>
  </div>
</section>
